module.exports = __webpack_public_path__ + "static/media/tv-retro.844d274d.svg";